<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
    <path
      d="M12.501 5.16699C16.8271 5.16699 20.3348 8.67392 20.335 13C20.335 17.3262 16.8272 20.834 12.501 20.834C8.1749 20.8338 4.66797 17.3261 4.66797 13C4.66815 8.67403 8.175 5.16717 12.501 5.16699Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 17.1667V13"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 9.87467V8.83301"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>
